/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  // Check if printer has been set or not
  if (localStorage.getItem("printer") == "" || localStorage.getItem("printer") == undefined || localStorage.getItem("printer") == null) localStorage.setItem("printer", 0); // Check if printer has been set or not

  if (localStorage.getItem("paperSize") == "" || localStorage.getItem("paperSize") == undefined || localStorage.getItem("paperSize") == null) localStorage.setItem("paperSize", 0);

  var printMyText = function printMyText() {
    var data = window.data;
    var printText = "";
    var print80Line = "";
    if (localStorage.getItem("paperSize") == 1) print80Line = "______________";
    printText += "Order:" + data.orderId + "{BR}";
    printText += "Date:" + data.dateTime + "{BR}";
    printText += print80Line + "_______________________________";
    window.DatecsPrinter.printText(printText, 'ISO-8859-1'); //data.receipt.length

    for (var i = 0; i < data.receipt.length; i++) {
      printText = "";
      printText += "{LEFT}";
      window.DatecsPrinter.printText("{BR}{BR}" + data.receipt[i].draw, 'ISO-8859-1');

      for (var j = 0; j < data.receipt[i].details.length; j++) {
        var adj0 = "";
        var adj1 = "";
        var adj2 = "";
        if (parseInt(data.receipt[i].details[j].amount[0].value) < 10) adj0 = " ";
        if (parseInt(data.receipt[i].details[j].amount[1].value) < 10) adj1 = " ";
        if (parseInt(data.receipt[i].details[j].amount[2].value) < 10) adj2 = " ";
        printText += "{BR}" + data.receipt[i].details[j].type + " {B}" + data.receipt[i].details[j].number + "{B}";
        if (data.receipt[i].details[j].position != "") printText += "" + data.receipt[i].details[j].position + "";else printText += "     ";
        if (localStorage.getItem("paperSize") == 0) printText += "{BR}";
        printText += "   B-" + data.receipt[i].details[j].amount[0].value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') + adj0 + "  S-" + data.receipt[i].details[j].amount[1].value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') + adj1 + "  A-" + data.receipt[i].details[j].amount[2].value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') + " ";
      }

      window.DatecsPrinter.printText(printText, 'ISO-8859-1');
    }

    window.DatecsPrinter.printText("{BR}{CENTER}" + print80Line + "_______________________________{BR}", 'ISO-8859-1');
    window.DatecsPrinter.printText("{H}{B}{RIGHT}TOTAL:" + data.total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') + "  {/RIGHT}{/B}{/H}", 'ISO-8859-1');
    window.DatecsPrinter.printText("{BR}{CENTER}" + print80Line + "_______________________________{BR}", 'ISO-8859-1');
    window.DatecsPrinter.printText("{BR}{BR}{CENTER}", 'ISO-8859-1'); //window.DatecsPrinter.printBarcode(75, data.orderId);   

    printMyBarcode(data.orderId);
  };

  var printMyImage = function printMyImage() {
    var image = new Image();
    image.src = 'static/images/gd.jpg';

    image.onload = function () {
      var canvas = document.createElement('canvas');
      canvas.height = 100;
      canvas.width = 100;
      var context = canvas.getContext('2d');
      context.drawImage(image, 0, 0);
      var imageData = canvas.toDataURL('image/jpeg').replace(/^data:image\/(png|jpg|jpeg);base64,/, ""); //remove mimetype

      window.DatecsPrinter.printImage(imageData, //base64
      canvas.width, canvas.height, 1, function () {
        printMyQR();
      });
    };
  };

  var printMyQR = function printMyQR() {
    var image = new Image();
    image.src = "https://chart.googleapis.com/chart?chs=300x300&cht=qr&chl=12345678&choe=UTF-8";

    image.onload = function () {
      var canvas = document.createElement('canvas');
      canvas.height = 300;
      canvas.width = 300;
      var context = canvas.getContext('2d');
      context.drawImage(image, 0, 0);
      var imageData = canvas.toDataURL('image/jpeg').replace(/^data:image\/(png|jpg|jpeg);base64,/, ""); //remove mimetype

      window.DatecsPrinter.printImage(imageData, //base64
      canvas.width, canvas.height, 1, function () {
        printMyText();
      });
    };
  };

  var printMyBarcode = function printMyBarcode(text) {
    var canvas = document.createElement("canvas");
    canvas.height = 400;
    canvas.width = 300;
    JsBarcode(canvas, text, {
      format: "EAN13"
    });
    var imageData = canvas.toDataURL('image/jpeg').replace(/^data:image\/(png|jpg|jpeg);base64,/, ""); //remove mimetype

    window.DatecsPrinter.printImage(imageData, //base64
    canvas.width, canvas.height, 1, function () {
      window.DatecsPrinter.writeHex('1B69'); //27,112,0,50,250
      // var open = new Uint8Array([27,112,0,50,250]);
      // window.DatecsPrinter.write(open);       

      window.DatecsPrinter.getStatus();
    });
  };

  var printPurchase = function printPurchase() {
    if (window.DatecsPrinter) {
      $f7.dialog.alert('Printing Now...');
      printMyImage();
    }
  };

  $on('pageInit', function () {
    if (!window.DatecsPrinter) {
      alert("DatecsPrinter plugin is missing. Have you installed the plugin? \nRun 'cordova plugin add cordova-plugin-datecs-printer'");
    } else {
      window.DatecsPrinter.listBluetoothDevices(function (devices) {
        window.DatecsPrinter.connect(devices[window.bluetooth].address, function () {}, function () {
          alert(JSON.stringify(error));
        });
      }, function (error) {
        alert(JSON.stringify(error));
      });
    }

    window.bluetooth = localStorage.getItem("printer");
    var raw = localStorage.getItem("receipt", raw);
    raw = "\n        {\n          \"status\":\"1\", \n          \"orderId\":\"123456789012\", \n          \"receipt\":[{\"draw\":\"04/08/21 (WED)\",\"details\":[{\"type\":\"GD\",\"number\":\"1234\",\"position\":\"\",\"amount\":[{\"type\":\"B\",\"value\":1.00},{\"type\":\"S\",\"value\":1.00},{\"type\":\"A\",\"value\":1.00}]},{\"type\":\"GD\",\"number\":\"2345\",\"position\":\"(b24)\",\"amount\":[{\"type\":\"B\",\"value\":24.00},{\"type\":\"S\",\"value\":24.00},{\"type\":\"A\",\"value\":24.00}]},{\"type\":\"GD\",\"number\":\"1234\",\"position\":\"(i24)\",\"amount\":[{\"type\":\"B\",\"value\":1.00},{\"type\":\"S\",\"value\":1.00},{\"type\":\"A\",\"value\":1.00}]},{\"type\":\"SG\",\"number\":\"1234\",\"position\":\"\",\"amount\":[{\"type\":\"B\",\"value\":1.00},{\"type\":\"S\",\"value\":1.00},{\"type\":\"A\",\"value\":1.00}]},{\"type\":\"SG\",\"number\":\"2345\",\"position\":\"(b24)\",\"amount\":[{\"type\":\"B\",\"value\":24.00},{\"type\":\"S\",\"value\":24.00},{\"type\":\"A\",\"value\":24.00}]},{\"type\":\"SG\",\"number\":\"1234\",\"position\":\"(i24)\",\"amount\":[{\"type\":\"B\",\"value\":1.00},{\"type\":\"S\",\"value\":1.00},{\"type\":\"A\",\"value\":1.00}]}]},{\"draw\":\"05/08/21 (THU)\",\"details\":[{\"type\":\"GD\",\"number\":\"1234\",\"position\":\"\",\"amount\":[{\"type\":\"B\",\"value\":1.00},{\"type\":\"S\",\"value\":1.00},{\"type\":\"A\",\"value\":1.00}]},{\"type\":\"GD\",\"number\":\"2345\",\"position\":\"(b24)\",\"amount\":[{\"type\":\"B\",\"value\":24.00},{\"type\":\"S\",\"value\":24.00},{\"type\":\"A\",\"value\":24.00}]},{\"type\":\"GD\",\"number\":\"1234\",\"position\":\"(i24)\",\"amount\":[{\"type\":\"B\",\"value\":1.00},{\"type\":\"S\",\"value\":1.00},{\"type\":\"A\",\"value\":1.00}]},{\"type\":\"SG\",\"number\":\"1234\",\"position\":\"\",\"amount\":[{\"type\":\"B\",\"value\":1.00},{\"type\":\"S\",\"value\":1.00},{\"type\":\"A\",\"value\":1.00}]},{\"type\":\"SG\",\"number\":\"2345\",\"position\":\"(b24)\",\"amount\":[{\"type\":\"B\",\"value\":24.00},{\"type\":\"S\",\"value\":24.00},{\"type\":\"A\",\"value\":24.00}]},{\"type\":\"SG\",\"number\":\"1234\",\"position\":\"(i24)\",\"amount\":[{\"type\":\"B\",\"value\":1.00},{\"type\":\"S\",\"value\":1.00},{\"type\":\"A\",\"value\":1.00}]}]},{\"draw\":\"06/08/21 (FRI)\",\"details\":[{\"type\":\"GD\",\"number\":\"1234\",\"position\":\"\",\"amount\":[{\"type\":\"B\",\"value\":1.00},{\"type\":\"S\",\"value\":1.00},{\"type\":\"A\",\"value\":1.00}]},{\"type\":\"GD\",\"number\":\"2345\",\"position\":\"(b24)\",\"amount\":[{\"type\":\"B\",\"value\":24.00},{\"type\":\"S\",\"value\":24.00},{\"type\":\"A\",\"value\":24.00}]},{\"type\":\"GD\",\"number\":\"1234\",\"position\":\"(i24)\",\"amount\":[{\"type\":\"B\",\"value\":1.00},{\"type\":\"S\",\"value\":1.00},{\"type\":\"A\",\"value\":1.00}]},{\"type\":\"SG\",\"number\":\"1234\",\"position\":\"\",\"amount\":[{\"type\":\"B\",\"value\":1.00},{\"type\":\"S\",\"value\":1.00},{\"type\":\"A\",\"value\":1.00}]},{\"type\":\"SG\",\"number\":\"2345\",\"position\":\"(b24)\",\"amount\":[{\"type\":\"B\",\"value\":24.00},{\"type\":\"S\",\"value\":24.00},{\"type\":\"A\",\"value\":24.00}]},{\"type\":\"SG\",\"number\":\"1234\",\"position\":\"(i24)\",\"amount\":[{\"type\":\"B\",\"value\":1.00},{\"type\":\"S\",\"value\":1.00},{\"type\":\"A\",\"value\":1.00}]}]}], \n          \"remarks\":\"\", \n          \"page\":\"\",\n          \"print\":0,\n          \"dateTime\":\"2021-08-04 01:54PM\",\n          \"total\":486.00\n        }\n        ";
    var data = JSON.parse(raw);
    window.data = data;
    console.log(data.total);
    JsBarcode("#barcode").options({
      font: "OCR-B"
    }) // Will affect all barcodes
    .EAN13(data.orderId, {
      fontSize: 18,
      textMargin: 0
    }).render();
    var htmlText = '';

    if (data.ALERT != undefined && data.ALERT != "") {
      $f7.dialog.alert(data.ALERT);
    }

    if (data.status == "1") {
      htmlText = "\n          <div style=\"text-align:center\">\n          <img  src=\"https://chart.googleapis.com/chart?chs=300x300&cht=qr&chl=" + data.orderId + "&choe=UTF-8\" title=\"Link to Google.com\" width=\"60%\"/>\n          </div>\n          <div class=\"card data-table\" style=\"background-color:#ffffff;color:#000000;\">\n            <table>\n              <thead>\n                <tr>\n                  <th class=\"label-cell\" style=\"color:#555555\">" + data.dateTime + "</th>\n                  <th class=\"numeric-cell\" style=\"color:#555555\">" + data.orderId + "</th>\n                </tr>\n              </thead>\n              <tbody>\n              <tr>\n                  <td colspan=2><hr/></td>\n              </tr>  \n          ";

      for (var i = 0; i < data.receipt.length; i++) {
        htmlText += "<tr><td colspan=2><p>" + data.receipt[i].draw + "</p><table>";

        for (var j = 0; j < data.receipt[i].details.length; j++) {
          htmlText += "  \n                <tr>\n                  <td style='font-size:12px'>" + data.receipt[i].details[j].type + "<span style='font-size:16px'><b>" + data.receipt[i].details[j].number + "</b></span></td>\n                  <td style='font-size:10px'>" + data.receipt[i].details[j].position + "</td>\n                  <td></td>\n\n                </tr>  \n                <tr>\n                  <td style='font-size:12px'>B" + data.receipt[i].details[j].amount[0].value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') + "</td>\n                  <td style='font-size:12px'>S" + data.receipt[i].details[j].amount[1].value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') + "</td>\n                  <td style='font-size:12px'>A" + data.receipt[i].details[j].amount[2].value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') + "</td>\n                </tr>    \n              ";
        }

        htmlText += "</table></td></tr>";
      }

      htmlText += "\n              <tr>\n                  <td colspan=2><hr/></td>\n              </tr> \n              <tr>\n                  <td></td>\n                  <td style='font-size:20px'><b>TOTAL $" + data.total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') + "</b></td>\n              </tr> \n              </tbody>\n            </table>\n          </div>\n          ";
      $('.printtext').html(htmlText);
      $update();
    }
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="about">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div>
      <div class="title">Receipt</div>
    </div>
  </div>
  <div class="page-content" style="background-color: white; color:black">
    <!-- <div class="block-title block-title-large">Receipt</div> -->
    <div class="printtext">

    </div>
    <div class="block">
      <div style="text-align: center;">
        <img id="barcode"/>
      </div>
      
      <p>
        <button class="button button-fill" @click=${printPurchase}>PRINT RECEIPT</button>
      </p>
    </div>
  </div>
</div>
`
    }
    ;
}

framework7Component.id = 'd2104fd25b';
export default framework7Component;